'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
import StoreLocator from './store-locator';

// Import JS Modules
import genericHelpers from '../_utils/generic-helpers';
import translate from '../_utils/tools/translate';

// -----------------------------------------------------------
//  Shipping
// -----------------------------------------------------------
const Shipping = ({ deliveryTimes, open, disabled, leftArrowPosition }) => {
  return (
    <aside className={classNames('delivery-info', { 'd-none': !open })}>
      <div className='arrow d-none d-md-block' style={{ left: leftArrowPosition }} />

      {disabled ? disabledContent() : enabledContent()}
    </aside>
  );

  function disabledContent() {
    return (
      <section className='delivery-info-section card-body'>
        <header className='header-bar'>
          <i className='fas fa-truck' /><strong>{translate('Shipping')}</strong>
        </header>

        {translate('Shipping')} is not available for your selection.
      </section>
    );
  }

  function enabledContent() {
    return [
      enabledS2SContent(),
      enabledS2HContent()
    ]
  }

  function enabledS2HContent() {
    const $post = deliveryTimesIncludesType('POST') &&
      <ul className="delivery-info-time">
        <li><strong>Standard {translate('Shipping')}</strong></li>
        <li className='lower-space'>{genericHelpers.calculateDeliveryDay(deliveryTimes['POST'])}</li>
      </ul>,

      $expressPost = deliveryTimesIncludesType('POST_EXPRESS') &&
        <ul className="delivery-info-time">
          <li><strong>Express {translate('Shipping')}</strong></li>
          <li className='lower-space'>{genericHelpers.calculateDeliveryDay(deliveryTimes['POST_EXPRESS'])}</li>
        </ul>,

      $courier = deliveryTimesIncludesType('COURIER') &&
        <ul className="delivery-info-time">
          <li><strong>Standard {translate('Shipping')} via Courier</strong></li>
          <li className='lower-space'>{genericHelpers.calculateDeliveryDay(deliveryTimes['COURIER'])}</li>
        </ul>,

      $expressCourier = deliveryTimesIncludesType('COURIER_EXPRESS') &&
        <ul className="delivery-info-time">
          <li><strong>Express {translate('Shipping')} via Courier</strong></li>
          <li className='lower-space'>{genericHelpers.calculateDeliveryDay(deliveryTimes['COURIER_EXPRESS'])}</li>
        </ul>,

      shouldDisplaySection = $post || $expressPost || $courier || $expressCourier;

    return (
      <section key='S2H' className='delivery-info-section card-body' style={{ display: (shouldDisplaySection ? 'block' : 'none') }}>
        <header className='header-bar'>
          <i className='fas fa-truck' /><strong>{translate('Ship')} to home</strong>
        </header>

        {$post}
        {$courier}

        {$expressPost}
        {$expressCourier}
      </section>
    );
  }

  function enabledS2SContent() {
    return (
      <section key='S2S' className='delivery-info-section card-body' style={{ display: (deliveryTimesIncludesType('PICKUP') ? 'block' : 'none') }}>
        <div className='header-bar'>
          <i className='fas fa-store' /><strong>{translate('Ship')} to store</strong>
        </div>

        <ul className="delivery-info-time">
          <li><strong>Free {translate('Shipping')}</strong></li>
          <li className='lower-space'>{deliveryTimes['PICKUP'] && genericHelpers.calculateDeliveryDay(deliveryTimes['PICKUP'])} </li>
        </ul>

        <StoreLocator exactNote={`You&apos;ll see exact ${translate('shipping')} dates when you checkout`} />
      </section>
    );
  }

  function deliveryTimesIncludesType(...types) {
    return types.some(type => deliveryTimes[type]);
  }
};

export default Shipping;
